import routes from "./routes"
import VueRouter from "vue-router"
import Vue from "vue"
import { ROUTE_PATHS } from "./route-paths"
import { masterScopesForRoute } from "./master-scopes"
import store from "../store"

Vue.use(VueRouter)

const router = new VueRouter({
    mode: "history",
    routes,
})

router.beforeEach(async (to, from, next) => {
    const publicPaths = [ROUTE_PATHS.LOGIN]
    if (!store.state.auth.authInitialized) {
        await store.dispatch("auth/initAuth")
    }
    const authenticated = store.getters["auth/authenticated"]

    if (!authenticated && !publicPaths.includes(to.path)) {
        next(ROUTE_PATHS.LOGIN)
        return
    }

    if (authenticated && to.path === ROUTE_PATHS.LOGIN) {
        next(ROUTE_PATHS.DASHBOARD)
        return
    }

    const masterScopes = masterScopesForRoute(to.path, store.state.auth.user)
    if (authenticated && masterScopes.length) {
        try {
            await store.dispatch("misc/fetchMainMasters", { scope: masterScopes })
        } catch (err) {
            console.error("Could not preload route master data", err)
        }
    }

    next()
})

export default router
